var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.24 82.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39a7df;}.cls-2{fill:#fff;}.cls-3{fill:#9b9a9a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.12,
    cy: 41.12,
    r: 35.2,
    transform: "translate(-1.67 1.74) rotate(-2.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.63,36.37a9.36,9.36,0,0,0-9.23-8.94H42.05V21.2a2,2,0,1,0-1.86,0v6.23H25.84a9.36,9.36,0,0,0-9.23,8.94,4.93,4.93,0,0,0-3.84,4.72v6a4.91,4.91,0,0,0,3.9,4.72A9.38,9.38,0,0,0,25.84,60H56.4a9.37,9.37,0,0,0,9.17-8.13,4.92,4.92,0,0,0,3.91-4.72v-6A4.94,4.94,0,0,0,65.63,36.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.12,0A41.12,41.12,0,1,0,82.24,41.12,41.12,41.12,0,0,0,41.12,0Zm0,79.88A38.76,38.76,0,1,1,79.88,41.12,38.76,38.76,0,0,1,41.12,79.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.42,53.88l-.57,0a9.4,9.4,0,1,1,0-18.8,10.62,10.62,0,0,1,7.54,3,18.91,18.91,0,0,1,2.69,3.23A18.91,18.91,0,0,1,43.81,38a10.63,10.63,0,0,1,7.54-3,9.4,9.4,0,1,1,0,18.8,9.49,9.49,0,0,1-7.22-2.6,19.54,19.54,0,0,1-3.06-3.79,19.18,19.18,0,0,1-3.06,3.79,9.42,9.42,0,0,1-6.64,2.62Zm7.75-9.54a19.09,19.09,0,0,0-3-3.89,7.35,7.35,0,0,0-5.28-2.07,6.09,6.09,0,1,0,0,12.16H31a6.23,6.23,0,0,0,4.84-1.73,21.1,21.1,0,0,0,3.35-4.48Zm12.18-6a7.37,7.37,0,0,0-5.28,2.07,19.45,19.45,0,0,0-3,3.89,21.44,21.44,0,0,0,3.35,4.48,6.23,6.23,0,0,0,4.85,1.73h.08a6.09,6.09,0,1,0,0-12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.8,43.53H32.32V42.05a.32.32,0,0,0-.32-.32H30.78a.32.32,0,0,0-.32.32v1.48H29a.32.32,0,0,0-.32.32v1.22a.32.32,0,0,0,.32.32h1.49v1.49a.32.32,0,0,0,.32.32H32a.32.32,0,0,0,.32-.32V45.39H33.8a.32.32,0,0,0,.32-.32V43.85A.32.32,0,0,0,33.8,43.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.35,
    y: 43.53,
    width: 5.47,
    height: 1.86,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.35,
    y: 43.53,
    width: 5.47,
    height: 1.86,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.78,43.53H32.32V42.07a.35.35,0,0,0-.35-.34H30.8a.34.34,0,0,0-.34.34v1.46H29a.35.35,0,0,0-.35.35v1.17a.35.35,0,0,0,.35.34h1.46v1.46a.35.35,0,0,0,.34.35H32a.35.35,0,0,0,.35-.35V45.39h1.46a.34.34,0,0,0,.34-.34V43.88A.35.35,0,0,0,33.78,43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.12,15.92a3.54,3.54,0,0,0-2.31.84.28.28,0,0,0,0,.4.26.26,0,0,0,.36,0,3,3,0,0,1,4,0,.26.26,0,0,0,.35,0,.28.28,0,0,0,0-.4A3.54,3.54,0,0,0,41.12,15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.65,14.17a7,7,0,0,0-9,0,.52.52,0,0,0,0,.77.52.52,0,0,0,.71,0A5.95,5.95,0,0,1,45,15a.51.51,0,0,0,.7,0h0A.52.52,0,0,0,45.65,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.12,14.38a5.13,5.13,0,0,0-3.31,1.21.39.39,0,0,0,0,.57.37.37,0,0,0,.51,0,4.34,4.34,0,0,1,5.64,0,.37.37,0,0,0,.51,0,.39.39,0,0,0,0-.57A5.13,5.13,0,0,0,41.12,14.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot01);
export default __webpack_public_path__ + "static/media/bot-01.1d328357b4f61073783857c8e3147a2e.svg";
export { ForwardRef as ReactComponent };